module.exports = __webpack_public_path__ + "img/Last image OOBE Portuguese.497ab635.png";